import { render, staticRenderFns } from "./SkeletonFriendList.vue?vue&type=template&id=134b60e4"
import script from "./SkeletonFriendList.vue?vue&type=script&lang=js"
export * from "./SkeletonFriendList.vue?vue&type=script&lang=js"
import style0 from "./SkeletonFriendList.vue?vue&type=style&index=0&id=134b60e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports